import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { Accordion } from "@itandi/itandi-bb-ui/Accordion";
import Styles from "./AccordionHtml.module.scss";

type Props = DeepReadonly<{
	html: string;
	maxHeightForClosed: number;
}>;

export function AccordionHtml({ html, maxHeightForClosed }: Props) {
	return (
		<Accordion maxHeightForClosed={maxHeightForClosed}>
			<div
				className={Styles.HtmlContent}
				dangerouslySetInnerHTML={{ __html: html }}
			/>
		</Accordion>
	);
}
